export const en = {
  appName: 'FORTEXA',
  home: 'Home',
  dashboard: 'Dashboard',
  reports: 'Reports',
  scans: 'Scans',
  settings: 'Settings',
  profile: 'Profile',
  login: 'Login',
  signup: 'Sign Up',
  register: 'Register',
  logout: 'Logout',
  upgrade: 'Upgrade',
  notifications: 'Notifications',
  language: 'Language',
  englishShort: 'EN',
  japanese: 'Japanese',
  japaneseNative: '日本語',
  toggleNavigationMenu: 'Toggle navigation menu',
  switchToJapanese: 'Switch to Japanese',
  switchToEnglish: 'Switch to English',
  fortexaLogoAlt: 'FORTEXA Logo',
  pro: 'PRO',
  securityScanner: 'Security Scanner',
  securityScan: 'Security Scan',
  scanHistory: 'Scan History',
  field: 'Field',
  page: 'Page',
  show: 'Show',
  hide: 'Hide',
  analyzing: 'Analyzing...',
  securityDisclaimer: 'Your credentials are never stored and are handled securely in-memory during the scan',
  configureScan: 'Configure Scan',
  enterCredentials: 'Enter Credentials',
  verifyConfiguration: 'Verify Configuration',
  detectedLoginForm: 'Detected Login Form',
  availableFields: 'Available Fields:',
  submitButton: 'Submit Button',
  tip: 'Tip:',
  loginSuccessful: 'Login Successful!',
  credentialsVerified: 'Credentials verified. Session cookies captured.',
  loginFailed: 'Login Failed',
  couldNotAuthenticateProvidedCredentials: 'Could not authenticate with provided credentials',
  authenticationVerified: 'Authentication Verified',
  readyToStartAuthenticatedSecurityScan: 'Ready to start authenticated security scan',
  targetLabel: 'Target:',
  loginUrlLabel: 'Login URL:',
  fieldsLabel: 'Fields:',
  credentialFields: 'credential field(s)',
  enter: 'Enter',
  selectFieldOption: '-- Select {label} --',
  targetUrlHelp: 'The main URL you want to analyze for vulnerabilities',
  loginPageUrlHelp: 'The URL of the login page (can be the same as your target)',
  detectionErrorLabel: 'Detection Error:',
  enterTargetAndLoginUrls: 'Enter the target URL to scan and the login page URL',
  authScanNoteTitle: 'Before You Start — Important Limitations',
  authScanNoteCaptcha: 'reCAPTCHA / CAPTCHA: If the login page requires a CAPTCHA check, automated login will fail. Temporarily disable CAPTCHA (or use a test/staging environment where it is not enforced) before running this scan.',
  authScanNoteMFA: 'Two-factor authentication (2FA / MFA): If the account requires a one-time code (SMS, email, or authenticator app) after entering the password, the tool cannot complete login. Use a test account with 2FA disabled.',
  authScanNoteOAuth: 'Social / SSO login (Google, Microsoft, etc.): Only standard username and password login forms are supported. If the application only offers "Sign in with Google" or similar buttons, the authenticated scan cannot be used.',
  authScanNoteWAF: 'IP blocking / bot detection: Some security systems may block automated requests. If the scan fails unexpectedly, the scan server\'s IP address may need to be whitelisted in the target environment.',
  scanComplete: 'Scan Complete',
  scanningInProgress: 'Scanning in Progress',
  securityScanCompletedReviewBelow: 'Security scan completed. Review the findings below.',
  runningAuthenticatedWebsiteScan: 'Running all security scanners on the authenticated website',
  fetchingPerformanceAndSecurityMetadata: 'Fetching performance & security metadata...',
  startingComprehensiveVulnerabilityScan: 'Starting comprehensive vulnerability scan...',
  generatingAiPoweredSecurityInsights: 'Generating AI-powered security insights...',
  finalizingResults: 'Finalizing results...',
  // Engine-agnostic scan progress (see frontend/src/utils/scanStatus.js).
  // Deliberately generic: clients must not learn which scanners are orchestrated.
  scanStepInProgress: 'Step {current} of {total} in progress...',
  scanningTarget: 'Scanning {target}...',
  vulnerabilityScan: 'Vulnerability Scan',
  vulnerabilityScanAuth: 'Vulnerability Scan (Authenticated)',
  threatIntelligence: 'Threat Intelligence',
  vulnerableHigh: 'Vulnerable (High)',
  vulnerableMedium: 'Vulnerable (Medium)',
  vulnerableLow: 'Vulnerable (Low)',
  runningSecurityTests: 'Running comprehensive security tests...',
  pageWillUpdateAutomatically: 'This page will automatically update when the scan completes.',
  urlsAndAlertsFound: 'Found {urls} URLs - {alerts} alerts so far',
  translatingReportToJapanese: 'Translating report to Japanese...',
  savingSchedule: 'Saving schedule...',
  scheduleCreatedSuccessfully: 'Schedule created successfully!',
  analysisComplete: 'Analysis complete!',
  analysisFailed: 'Analysis failed: {reason}',
  scanWasStopped: 'Scan was stopped',
  stoppingScan: 'Stopping scan...',
  stoppingScanAndRestartingContainers: 'Stopping scan and restarting containers...',
  scanStoppedContainersRestartingForFreshEnvironment: 'Scan stopped - containers restarting for fresh environment',
  stopRequestSent: 'Stop request sent...',
  failedToStopScanWithReason: 'Failed to stop scan: {reason}',
  scanRequestAccepted: 'Scan request accepted...',
  initializingScan: 'Initializing scan...',
  analyzingTargetEnvironment: 'Analyzing target environment...',
  performingComprehensiveSiteAnalysis: 'Performing comprehensive site analysis...',
  aiGeneratedAnalysisSummary: 'AI-Generated Analysis Summary',
  generatingAiAnalysisWaitingForAllScanData: 'Generating AI analysis... (waiting for all scan data)',
  uploadProgress: 'Uploading {progress}%',
  scanning: 'Scanning...',
  pending: 'Pending',
  valid: 'Valid',
  unavailable: 'Unavailable',
  headersPresent: 'Headers Present',
  technologiesDetected: 'Technologies Detected',
  noTechnologiesDetected: 'No technologies detected',
  scanFailed: 'Scan Failed',
  passed: 'Passed',
  starting: 'Starting',
  notSet: 'Not Set',
  securityHeaders: 'Security Headers',
  performance: 'Performance',
  outOf100: 'out of 100',
  securityConfig: 'Security Config',
  malicious: 'Malicious',
  threatScore: 'threat score',
  sslCertificate: 'SSL Certificate',
  unknownIssuer: 'Unknown Issuer',
  techStack: 'Tech Stack',
  wafStatus: 'WAF Status',
  scoreOf100: 'Score: {score}/100',
  optimizationScore: 'Optimization Score',
  mxRecordsFound: 'MX Records Found',
  noMailServer: 'No Mail Server',
  domainRegistered: 'Domain Registered',
  enabled: 'Enabled',
  disabled: 'Disabled',
  preloaded: 'Preloaded',
  notPreloaded: 'Not Preloaded',
  clean: 'Clean',
  foundCount: '{count} Found',
  listsChecked: '{count} Lists Checked',
  green: 'Green',
  standard: 'Standard',
  hosting: 'Hosting',
  notArchived: 'Not Archived',
  historicalSnapshots: 'Historical Snapshots',
  timeout: 'Timeout',
  notFound: 'Not Found',
  urlsInSitemap: 'URLs in Sitemap',
  complete: 'Complete',
  partial: 'Partial',
  missing: 'Missing',
  linksFound: 'Links Found',
  redirectHops: 'Redirect Hops',
  serversFound: 'Servers Found',
  dnssecStatus: 'DNSSEC Status',
  securityPolicy: 'Security Policy',
  redirectTo: 'Redirected to:',
  tryDifferentSubmitButton: 'If login fails, try selecting a different submit button from the dropdown above and test again.',
  selectLoginFieldsAndEnterCredentials: 'Select the login fields and enter your credentials',
  reviewConfigurationAndStartAuthenticatedSecurityScan: 'Review your configuration and start the authenticated security scan',
  englishOnlyValidationFailed: 'English-only validation failed',
  publicWebsiteScan: 'Public Website Scan',
  authenticatedWebsiteScan: 'Authenticated Website Scan',
  chooseScanTypePrefix: 'Choose Your',
  chooseScanTypeHighlight: 'Scan Type',
  chooseScanTypeSubtitle: 'Select the type of security scan you want to perform',
  publicScanDescription: 'Comprehensive security analysis for publicly accessible websites. Includes deep vulnerability scanning, performance optimization checks, and security metadata analysis.',
  authScanDescription: 'Deep security analysis for login-protected areas. Automatically detects login interfaces, validates credentials, and performs in-depth scans on authenticated areas.',
  comprehensiveVulnerabilityScan: 'Comprehensive Vulnerability Scan',
  sitePerformanceAnalysis: 'Site Performance Analysis',
  securityHeaderAnalysis: 'Security Header Analysis',
  websiteHealthCheck: 'Website Health Check',
  noLoginRequired: 'No Login Required',
  autoDetectLoginForms: 'Auto-Detect Login Forms',
  credentialValidation: 'Credential Validation',
  inDepthAuthenticatedScan: 'In-Depth Authenticated Scan',
  cookieSessionManagement: 'Cookie-Based Session Management',
  serverSideCredentialHandling: 'Server-Side Credential Handling',
  scheduleScan: 'Schedule Scan',
  startPublicScan: 'Start Public Scan',
  startAuthenticatedScan: 'Start Authenticated Scan',
  credentialsSecurityNote: 'Your credentials are never stored and are handled securely in-memory during the scan',
  heroTitle: 'Visualizing Security Risks Across Websites and Web Applications',
  scanNotice: 'Scan running in the background — you will be notified when complete. Safe to close this tab or turn off your device.',
  enterUrlToStart: 'Enter a URL to start',
  urlExample: 'https://example.com',
  analyzeUrl: 'Analyze URL',
  startScan: 'Start Scan',
  stopScan: 'Stop Scan',
  runningSecurityScans: 'Running security scans...',
  resumingScan: 'Resuming scan...',
  unknownError: 'Unknown error',
  noAnalysisId: 'No analysisId in response',
  stoppingScanRestarting: 'Stopping scan and restarting containers...',
  scanStoppedRestarting: 'Scan stopped - containers restarting for fresh environment',
  failedStopScan: 'Failed to stop scan',
  enterUrlToScan: 'Enter URL to scan (e.g., https://example.com)',
  saveScheduledScan: 'Save Scheduled Scan',
  schedulingModeActive: 'Scheduling Mode Active',
  settingUpPublicScan: 'Setting up a public scan for {date} at {time}',
  settingUpAuthScan: 'Setting up an authenticated scan for {date} at {time}',
  loadingScanResults: 'Loading scan results...',
  combinedScanReport: 'Combined Scan Report',
  combinedScanReportTarget: ' for {target}',
  websiteScreenshot: 'Website Screenshot',
  unableToLoadScan: 'Unable to Load Scan',
  backToProfile: 'Back to Profile',
  historicalScan: 'Historical Scan',
  scannedOn: 'Scanned on',
  scanNotFound: 'Scan not found or has expired. Scans are automatically deleted after 7 days.',
  failedToLoadScan: 'Failed to load scan',
  failedToLoadScanTryAgain: 'Failed to load scan. Please try again.',
  loadingProfile: 'Loading profile...',
  sessionExpiredLoginAgain: 'Session expired. Please log in again.',
  failedFetchProfile: 'Failed to fetch profile',
  failedLoadProfile: 'Failed to load profile. Check console for details.',
  failedUpdateProfile: 'Failed to update profile',
  profileUpdated: 'Profile updated successfully!',
  myProfile: 'My Profile',
  accountInformation: 'Account Information',
  editProfile: 'Edit Profile',
  save: 'Save',
  cancel: 'Cancel',
  name: 'Name',
  email: 'Email',
  password: 'Password',
  bio: 'Bio',
  accountType: 'Account Type',
  memberSince: 'Member Since',
  lastLogin: 'Last Login',
  noBioAdded: 'No bio added yet',
  bioPlaceholder: 'Tell us about yourself (max 500 characters)',
  statistics: 'Statistics',
  totalScans: 'Total Scans',
  thisMonth: 'This Month',
  dailyLimit: 'Daily Limit',
  maxFileSize: 'Max File Size',
  noPlanScanLimit: 'No plan',
  planScanLimitLabel: 'Plan Scan Limit',
  extraScansRemainingLabel: 'Extra Scans Remaining',
  extraScansExpireOn: 'Expires {date}',
  topUpSectionTitle: 'Need More Scans?',
  topUpSectionDescription: 'Used up your monthly allowance? Add one-off scans on top of your current plan. Extra scans are used only after your monthly allowance is exhausted.',
  planLimitExhaustedHint: "You've used all scans included in your plan this month. Purchase extra scans below to keep scanning.",
  buyExtraScans: 'Buy Extra Scans',
  recentScans: 'Recent Scans',
  noScansYet: 'No scans yet. Start by analyzing a URL!',
  scheduledScan: 'Scheduled Scan',
  clickViewScanResults: 'Click to view scan results (Status: {status})',
  upgradeToPro: 'Upgrade to Pro',
  choosePlan: 'Choose Your Plan',
  unlockPremiumFeatures: 'Unlock premium features:',
  unlimitedScans: 'Unlimited scans per day',
  largerFileLimit: 'Larger file size limit (100MB)',
  priorityQueue: 'Priority scanning queue',
  advancedAnalyticsReports: 'Advanced analytics reports',
  apiAccessComingSoon: 'API access (coming soon)',
  selectPlan: 'Select Plan',
  startingCheckout: 'Redirecting to checkout...',
  checkoutFailed: 'Failed to start checkout. Please try again.',
  paymentProcessing: 'Payment received. Activating your plan...',
  checkingPlanStatus: 'Checking plan status...',
  refreshPlanStatus: 'Refresh Status',
  paymentPendingActivation: 'Payment succeeded, but activation is still syncing. Please refresh in a few moments.',
  paymentSuccess: 'Payment successful! Your plan has been activated.',
  paymentCancelled: 'Payment was cancelled. No charges were made.',
  currentPlanTitle: 'Your Plan',
  planStatus: 'Status',
  planStatusActive: 'Active',
  planStatusPastDue: 'Payment Past Due',
  scansUsedLabel: 'Scans Used This Month',
  seatsUsedLabel: 'Seats Used',
  teamManagement: 'Team Management',
  emailAddress: 'Email Address',
  sendInvite: 'Send Invite',
  activeMembers: 'Active Members',
  pendingInvites: 'Pending Invites',
  revoke: 'Revoke',
  revokeInvite: 'Revoke Invite',
  inviteSentSuccess: 'Invite sent to {email}',
  inviteEmailFailed: 'Invite created but email delivery failed. Share this link manually: {link}',
  inviteRevokeFailed: 'Failed to revoke invite',
  oneTimeScansRemaining: 'Scans Remaining',
  planExpiresLabel: 'Plan Expires',
  cancelSubscriptionNote: 'Your plan remains active until the end of the billing period.',
  subscriptionCancelled: 'Subscription cancelled. Access continues until the end of the billing period.',
  proSubscription: 'Pro Subscription',
  proActiveUntil: 'Your Pro subscription is active until:',
  cancelProReturnFree: 'Cancel Pro & Return to Free',
  upgradeNow: 'Upgrade Now',
  cancelProSubscription: 'Cancel Pro Subscription',
  downgradeConfirmMessage: "Are you sure you want to cancel your subscription? You'll keep access until the end of the current billing period.",
  cancelSubscription: 'Cancel Subscription',
  keepPro: 'Keep Plan',
  billingMonthly: 'Monthly',
  billingAnnual: 'Annual',
  billingOneTime: 'One-Time Trial',
  discount17Percent: '17% OFF',
  mostPopular: 'Most Popular',
  planLight: 'Light Plan',
  planBasic: 'Basic Plan',
  planPro: 'Pro Plan',
  planTrial1: 'Trial 1',
  planTrial2: 'Trial 2',
  periodMonth: '/month',
  periodYear: '/year',
  planAccounts: '{count} account{plural}',
  planScansPerMonth: '{count} scans/month',
  planScansForTarget: '{count} scan{plural} for 1 target',
  trial1ScansAndDevice: '1 device / 1 scan',
  trial2ScansAndDevice: '1 device / 2 scans',
  validityPeriod: 'Validity Period: 90 days',
  severityAllLevels: 'All severity levels',
  severityCriticalHighOnly: 'Critical + High only',
  failedCancelSubscription: 'Failed to cancel subscription',
  failedSendInvite: 'Failed to send invite',
  loginTitle: 'Login',
  loggingIn: 'Logging in...',
  loginWithGoogle: 'Login with Google',
  googleLoginSuccessful: 'Google login successful! Redirecting...',
  googleLoginFailed: 'Google Login failed. Please try again.',
  googleLoginFailedShort: 'Google Login Failed',
  inviteEmailMismatch: 'This invitation was sent to another email address. Please sign in using the invited Google account or the invited email.',
  loginFailedLater: 'Login failed. Please try again later.',
  newUser: 'New user?',
  registerNow: 'Register now',
  forgotPassword: 'Forgot Password?',
  registerTitle: 'Register',
  registering: 'Registering...',
  signUpWithGoogle: 'Sign up with Google',
  googleSignupSuccessful: 'Google sign up successful! Redirecting...',
  googleSignupFailed: 'Google sign up failed. Please try again.',
  googleSignupFailedShort: 'Google Sign Up Failed',
  registrationFailedLater: 'Registration failed. Please try again later.',
  haveAccount: 'Have an account already?',
  logIn: 'Log in',
  or: 'OR',
  forgotPasswordDescription: "Enter your email address and we'll send you a link to reset your password.",
  sending: 'Sending...',
  sendResetLink: 'Send Reset Link',
  rememberPassword: 'Remember your password?',
  resetPassword: 'Reset Password',
  resetPasswordDescription: 'Enter your new password below.',
  newPassword: 'New Password',
  confirmNewPassword: 'Confirm New Password',
  resetting: 'Resetting...',
  invalidResetLink: 'Invalid reset link',
  passwordsDoNotMatch: 'Passwords do not match',
  passwordMinLength: 'Password must be at least 6 characters long',
  genericErrorLater: 'An error occurred. Please try again later.',
  verifyEmail: 'Verify Your Email',
  otpSentTo: "We've sent a 6-digit code to",
  enterOtp: 'Enter 6-digit code',
  verifying: 'Verifying...',
  verify: 'Verify',
  resendCode: 'Resend Code',
  otpVerificationSuccess: 'Verification successful! Welcome!',
  verificationFailed: 'Verification failed. Please try again.',
  otpSentSuccess: 'OTP sent successfully. Please check your email.',
  resendOtpFailed: 'Failed to resend OTP. Please try again.',
  wrongEmail: 'Wrong email?',
  goBackToLogin: 'Go back to login',
  scheduledScans: 'Scheduled Scans',
  failedFetchSchedules: 'Failed to fetch schedules',
  failedDeleteSchedule: 'Failed to delete schedule',
  failedTriggerScan: 'Failed to trigger scan',
  scheduledScansSubtitle: 'Manage your one-time and recurring security scans',
  newSchedule: '+ New Schedule',
  activeSchedules: 'Active Schedules',
  loadingSchedules: 'Loading schedules...',
  noScheduledScans: 'No Scheduled Scans',
  noScheduledScansDescription: 'Create your first scheduled scan to automatically run security tests on your targets.',
  goDashboardSchedule: 'Go to Dashboard to Schedule',
  sslStatus: 'SSL Status',
  fetched: 'Fetched',
  public: 'Public',
  auth: 'Auth',
  recurring: 'Recurring',
  oneTime: 'One-Time',
  recurrence: 'Recurrence',
  nextRun: 'Next Run',
  lastRun: 'Last Run',
  lastFailure: 'Last failure: {reason}',
  runNow: 'Run Now',
  edit: 'Edit',
  delete: 'Delete',
  deleteSchedulePrompt: 'Delete this schedule?',
  yesDelete: 'Yes, Delete',
  scheduled: 'Scheduled',
  running: 'Running',
  completed: 'Completed',
  failed: 'Failed',
  dayAtTime: 'Day{plural} {days} at {time}',
  notAvailable: 'N/A',
  emDash: '—',
  scheduleAScan: 'Schedule a Scan',
  editSchedule: 'Edit Schedule',
  targetUrlReadOnly: 'Target URL (Read Only)',
  scheduleMode: 'Schedule Mode',
  pickDateTime: 'Pick date & time',
  autoRepeat: 'Auto-repeat',
  date: 'Date',
  time: 'Time',
  selectDate: 'Select Date',
  today: 'Today',
  selectedTime: 'Selected: {time}',
  frequency: 'Frequency',
  twiceMonthly: 'twice monthly',
  custom: 'custom',
  monthly: 'monthly',
  daysOfMonth: 'Day(s) of Month',
  executionTime: 'Execution Time',
  processing: 'Processing...',
  updateSchedule: 'Update Schedule',
  continueToConfig: 'Continue to Config',
  pleaseLoginSchedule: 'Please log in to schedule scans',
  pleaseSelectDateTime: 'Please select a date and time',
  invalidDateTime: 'Invalid date/time',
  scheduledTimeFuture: 'Scheduled time must be in the future',
  scheduledTimeWithinMonth: 'Scheduled time must be within 1 month from now',
  pleaseSelectDay: 'Please select at least one day',
  configSavedRedirecting: 'Configuration saved! Redirecting...',
  scheduleUpdated: 'Schedule updated!',
  scanScheduledSuccess: 'Scan scheduled successfully!',
  failedSaveSchedule: 'Failed to save schedule',
  scanCompleted: 'Scan Completed',
  scanCompletedMessage: 'Your {scanType} for {target} has completed successfully.',
  targetUrl: 'target URL',
  dismiss: 'Dismiss',
  viewReport: 'View Report',
  configure: 'Configure',
  credentials: 'Credentials',
  verifyStep: 'Verify',
  results: 'Results',
  dismissError: 'Dismiss',
  targetWebsiteUrl: 'Target Website URL',
  loginPageUrl: 'Login Page URL',
  detectLoginFields: 'Detect Login Fields',
  detecting: 'Detecting...',
  back: 'Back',
  continue: 'Continue',
  testLogin: 'Test Login',
  testingLogin: 'Testing Login...',
  startAuthenticatedSecurityScan: 'Start Authenticated Security Scan',
  startNewScan: 'Start New Scan',
  pleaseFillCredentials: 'Please fill in all credential fields',
  detectionFailed: 'Detection failed',
  couldNotAnalyzeLogin: 'Could not analyze the login page',
  noLoginFormsDetected: 'No login forms detected on this page.',
  loginTestFailed: 'Login test failed',
  sessionExpiredTestAgain: 'Session expired. Please test login again.',
  failedStartScan: 'Failed to start scan',
  failedGetScanStatus: 'Failed to get scan status',
  scanStoppedByUser: 'Scan stopped by user',
  selectLabel: '-- Select {label} --',
  aiSecurityReport: 'AI Security Report',
  findings: 'Findings',
  recommendations: 'Recommendations',
  severity: 'Severity',
  vulnerabilityAnalysisResults: 'Vulnerability Analysis Results',
  alertTypes: 'Alert Types',
  totalOccurrences: 'Total Occurrences',
  jsonReport: 'JSON Report',
  pdfReport: 'PDF Report',
  downloading: 'Downloading...',
  generatingLang: 'Generating {lang}...',
  englishPdf: 'English PDF',
  japanesePdf: 'Japanese PDF',
  high: 'High',
  medium: 'Medium',
  low: 'Low',
  informational: 'Informational',
  occurrence: 'occurrence',
  occurrences: 'occurrences',
  description: 'Description',
  solution: 'Solution',
  affectedUrls: 'Affected URLs ({count} shown{more})',
  moreInFullReport: ', more in full report',
  vulnerabilityAffectsUrls: 'This vulnerability affects {count} URLs total. Download the full report to see all affected URLs.',
  requestResponseEvidence: 'Request / Response Evidence',
  evidenceRequest: 'Request',
  evidenceResponse: 'Response',
  loadingEvidence: 'Loading request/response data…',
  noEvidenceCaptured: 'No raw request/response was captured for this finding.',
  showAllEvidence: 'Show all {count} request/response pairs',
  showLessEvidence: 'Show fewer',
  evidenceFullInJson: 'Full request/response for every occurrence is available in the JSON report.',
  noVulnerabilities: 'No security vulnerabilities detected. Great job!',
  failedDownloadDetailedReport: 'Failed to download detailed report',
  failedDownloadPdfReport: 'Failed to download PDF report: {message}',
  geminiKeyExhausted: 'AI service temporarily unavailable. Please try again later.',
  englishPdfOnly: 'English PDF must contain English only',
  pdfDownloadFailed: 'PDF download failed',
  downloadScanReports: 'Download Scan Reports',
  downloadCompleteSecurityResults: 'Download your complete security scan results in your preferred format',
  generating: 'Generating...',
  downloadPdfReport: 'Download PDF Report',
  englishVersion: 'English Version',
  japaneseVersion: 'Japanese Version',
  downloadJsonData: 'Download JSON Data',
  initializingEnglishPdf: 'Initializing English PDF...',
  initializingJapanesePdf: 'Initializing Japanese PDF...',
  formattingScanData: 'Formatting scan data...',
  waitingRateLimit: 'Waiting for API rate limit...',
  formattingAiAnalysis: 'Formatting AI analysis...',
  renderingPdfDocument: 'Rendering PDF document...',
  finalizing: 'Finalizing...',
  translatingToJapanese: 'Preparing Japanese report...',
  downloadComplete: 'Download complete!',
  failedDownloadReportTryAgain: 'Failed to download report. Please try again.',
  pdfProgressNote: 'PDF generation formats the report and may take up to 2 minutes.',
  downloadNote: 'PDF: Professional bilingual report (EN + JA) | JSON: Raw data for analysis',
  viewSiteHealthAnalysis: 'View Site Health Analysis ({count} components analyzed)',
  viewUrlscanAnalysis: 'View Threat Intelligence Analysis',
  urlscanSecurityVerdict: 'Security Verdict',
  urlscanOverall: 'Overall',
  urlscanThreatScore: 'Threat Score',
  urlscanUrlscanScore: 'Reputation Score',
  urlscanEngineDetections: 'Engine Detections',
  urlscanCommunityScore: 'Community Score',
  urlscanMalicious: 'MALICIOUS',
  urlscanClean: 'CLEAN',
  urlscanMaliciousCount: '{count} malicious',
  urlscanPageInformation: 'Page Information',
  urlscanDomain: 'Domain',
  urlscanIpAddress: 'IP Address',
  urlscanCountry: 'Country',
  urlscanServer: 'Server',
  urlscanTlsIssuer: 'TLS Issuer',
  urlscanTlsValidDays: 'TLS Valid Days',
  urlscanNetworkStatistics: 'Network Statistics',
  urlscanHttpRequests: 'HTTP Requests',
  urlscanUniqueIps: 'Unique IPs',
  urlscanUniqueCountries: 'Unique Countries',
  urlscanDataTransferred: 'Data Transferred',
  urlscanAllDataShown: 'All threat intelligence and page analysis data from this scan is displayed above.',
  mozillaObservatorySecurityConfiguration: 'Security Configuration',
  obsSecurityGrade: 'Security Grade',
  obsScore: 'Score',
  obsTestsPassed: 'Tests Passed',
  obsTestsFailed: 'Tests Failed',
  obsGradeA: 'Excellent security configuration',
  obsGradeB: 'Good configuration with minor gaps',
  obsGradeC: 'Moderate risk — several headers missing',
  obsGradeD: 'Poor configuration — significant exposure',
  obsGradeF: 'Critical — most security headers absent',
  obsRecommendedFixes: 'Recommended Security Header Fixes',
  obsCspDesc: 'prevents cross-site scripting (XSS) and data injection attacks',
  obsHstsDesc: 'forces HTTPS and prevents SSL-stripping attacks',
  obsXctoDesc: 'blocks MIME-type sniffing that can enable drive-by downloads',
  obsXfoDesc: 'prevents clickjacking by blocking framing from untrusted origins',
  obsRpDesc: 'limits referrer data leakage to third-party sites',
  obsPpDesc: 'restricts access to browser features (camera, microphone, geolocation)',
  obsNoData: 'Security header analysis data not available for this URL.',
  sslCertificateDetails: 'SSL Certificate Details',
  subject: 'Subject',
  issuer: 'Issuer',
  validFrom: 'Valid From',
  validTo: 'Valid To',
  serial: 'Serial',
  validation: 'Validation',
  dnsRecords: 'DNS Records',
  mxRecords: 'MX Records',
  txtRecords: 'TXT Records',
  found: 'found',
  technologyStack: 'Technology Stack',
  openPorts: 'Open Ports',
  open: 'Open',
  noOpenPorts: 'No common ports detected as open',
  closedFilteredPorts: 'Closed/Filtered ports ({count})',
  cookies: 'Cookies',
  headerCookies: 'Header Cookies',
  clientCookies: 'Client Cookies',
  viewHeaderCookies: 'View header cookies ({count})',
  viewClientCookies: 'View client cookies ({count})',
  whoisInformation: 'WHOIS Information',
  registrar: 'Registrar',
  created: 'Created',
  expires: 'Expires',
  updated: 'Updated',
  nameservers: 'Nameservers',
  domainStatus: 'Domain Status',
  mailConfiguration: 'Mail Configuration',
  mailServices: 'Mail Services',
  noneDetected: 'None detected',
  mailTxtRecords: 'Mail TXT records ({count})',
  tlsSecurityAnalysis: 'TLS Security Analysis',
  grade: 'Grade',
  score: 'Score',
  host: 'Host',
  socialMediaTags: 'Social Media Tags',
  twitterCard: 'Twitter Card',
  themeColor: 'Theme Color',
  redirectChain: 'Redirect Chain',
  webArchiveHistory: 'Web Archive History',
  totalSnapshots: 'Total Snapshots',
  available: 'Available',
  firstSnapshot: 'First Snapshot',
  lastSnapshot: 'Last Snapshot',
  carbonFootprint: 'Carbon Footprint',
  greenHosting: 'Green Hosting',
  yes: 'Yes',
  no: 'No',
  co2PerVisit: 'CO2 per visit',
  cleanerThan: 'Cleaner than',
  ofSites: 'of sites',
  robotsTxt: 'Robots.txt',
  noRobotsTxt: 'No robots.txt file found',
  sitemap: 'Sitemap',
  noSitemap: 'No sitemap found',
  urls: 'URLs',
  viewSitemaps: 'View sitemaps ({count})',
  viewUrls: 'View URLs ({count})',
  dnsServer: 'DNS Server',
  server: 'Server',
  provider: 'Provider',
  country: 'Country',
  status: 'Status',
  enabledValid: 'Enabled & Valid',
  notEnabled: 'Not Enabled',
  algorithm: 'Algorithm',
  keyTag: 'Key Tag',
  digestType: 'Digest Type',
  dsRecords: 'DS Records',
  dnskeyRecords: 'DNSKEY Records',
  websiteRanking: 'Website Ranking',
  top100: 'Top 100',
  top1k: 'Top 1K',
  top10k: 'Top 10K',
  top100k: 'Top 100K',
  top1m: 'Top 1M',
  trafficRank: 'Traffic Rank',
  notGlobalTop1m: 'Not found in the global top 1M domains list.',
  httpStatus: 'HTTP Status',
  responseTime: 'Response Time',
  traceRoute: 'Trace Route',
  allHopsUnreachable: 'All {count} hops were unreachable (likely blocked by a firewall or CDN).',
  unreachableHopsHidden: '{count} unreachable hop{plural} hidden',
  traceRouteDataAvailable: 'Trace route data available',
  ipAddress: 'IP Address',
  ip: 'IP',
  version: 'Version',
  location: 'Location',
  isp: 'ISP',
  organization: 'Organization',
  firewall: 'Firewall',
  tlsGrade: 'TLS Grade',
  quality: 'Quality',
  mailConfig: 'Mail Config',
  securityBlacklist: 'Security Blacklist',
  carbon: 'Carbon',
  archives: 'Archives',
  socialTags: 'Social Tags',
  links: 'Links',
  redirects: 'Redirects',
  rank: 'Rank',
  alerts: 'Alerts',
  alertsCount: '{count} Alerts',
  alertsCountPartial: '{count} Alerts (Partial)',
  crawlerRules: 'Crawler Rules',
  globalRank: 'Global Rank',
  qualityMetrics: 'Quality Metrics',
  overall: 'Overall',
  accessibility: 'Accessibility',
  bestPractices: 'Best Practices',
  seo: 'SEO',
  pwa: 'PWA',
  loadingExperience: 'Loading Experience',
  qualityDataAvailable: 'Quality data available',
  // WebCheck detail labels
  subjectAltNames: 'Subject Alt Names ({count})',
  sha256Label: 'SHA-256',
  httpHeaders: 'HTTP Headers',
  firewallWafDetection: 'Firewall / WAF Detection',
  wafDetected: 'WAF Detected',
  notDetected: 'Not Detected',
  wafNameLabel: 'Name',
  confidence: 'Confidence',
  hstsFullTitle: 'HSTS (HTTP Strict Transport Security)',
  maxAge: 'Max-Age',
  includeSubdomains: 'Include Subdomains',
  seconds: 'seconds',
  days: 'days',
  securityTxtTitle: 'Security.txt',
  noSecurityTxtFound: 'No security.txt file found',
  contactLabel: 'Contact',
  languagesLabel: 'Languages',
  canonicalLabel: 'Canonical',
  viewFullSecurityTxt: 'View full security.txt',
  blockLists: 'Block Lists',
  listedOnBlocklists: 'Listed on {count} blocklist(s)',
  notListedOnBlocklists: 'Not listed on any blocklists',
  cleanOnLists: 'Clean on {count} lists',
  blockListDataAvailable: 'Block list data available',
  blockedLabel: 'Blocked',
  linkedPages: 'Linked Pages',
  internalLinks: 'Internal Links',
  externalLinks: 'External Links',
  viewInternalLinks: 'View internal links ({count})',
  viewExternalLinks: 'View external links ({count})',
  urlLabel: 'URL',
  dnsServerInfoAvailable: 'DNS server information available',
  dnssecTitle: 'DNSSEC',
  hopLabel: 'Hop',
  rttLabel: 'RTT',
  ogTitleLabel: 'OG Title',
  ogDescriptionLabel: 'OG Description',
  ogImageLabel: 'OG Image',
  serverN: 'Server {n}',
  priorityLabel: 'priority',
  // ZapReportEnhanced labels
  translatingVulnerabilityData: 'Translating vulnerability data to Japanese...',
};
